import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './otherFormats.module.scss'
import { Text, PrimaryButton, Spacing } from 'DVWebNodeUI'
import { LocalizerProps, withLocalization } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'


export interface IOtherFormatsProps {
  content?: WpsRuntime.atv.wps.OtherFormatsModelProps
}

type LocalizedOtherFormatsProps = IOtherFormatsProps & LocalizerProps

const LocalizedOtherFormats = ({content, getString}: LocalizedOtherFormatsProps) => {
  if (!content || !content.actions.length) {
    return null
  }
  return <>
    <h1 className={Spacing.base}> {getString(StringId.DV_DP_CL_other_formats_title)} </h1>
    {content.actions.map((action: WpsRuntime.atv.wps.FormatActionProps) => {
      return <div className={st.otherFormats}>
        <PrimaryButton href={action.link} forceDoubleHeight={true}>
          <Text tag="span" string={action.text}/>
        </PrimaryButton>
      </div>
    })}
  </>
}

export const OtherFormats = withLocalization(LocalizedOtherFormats)